import { createTheme } from "@material-ui/core";
import { Overrides } from "@material-ui/core/styles/overrides";
import { dalCustomColorsDark } from "./dalCustomColorsDark";

export const dalThemeDark = createTheme({
    palette: {
        primary: {
            main: dalCustomColorsDark.primary
        },
        error: {
            main: dalCustomColorsDark.error
        },
        background: {
            paper: dalCustomColorsDark.darkSecondary
        },
        action: {
            active: dalCustomColorsDark.darkForeground
        },
        type: "dark"
    },
    typography: {
        fontFamily: "Silka"
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                boxShadow: "none",
                backgroundColor: dalCustomColorsDark.white,
                "&.Mui-disabled": {
                    backgroundColor: dalCustomColorsDark.white
                },
                border: `2px solid ${dalCustomColorsDark.primary}`,
                "&:hover": {
                    backgroundColor: dalCustomColorsDark.primary,
                    boxShadow: "none",
                    "& .MuiButton-label": {
                        color: dalCustomColorsDark.white
                    }
                }
            },
            root: {
                "&.Mui-disabled": {
                    opacity: 0.2
                },
                textTransform: "none",
                transition: "none",
                borderRadius: 4,
                padding: "16px 24px 16px 24px"
            },
            label: {
                color: dalCustomColorsDark.primary
            }
        },
        MuiCheckbox: {
            root: {
                color: dalCustomColorsDark.disabledElements,
                padding: 0,
                "&.MuiIconButton-colorSecondary:hover": {
                    backgroundColor: "transparent"
                }
            },
            colorSecondary: {
                "&.Mui-checked": {
                    color: dalCustomColorsDark.primary
                }
            }
        },
        MuiChip: {
            root: {
                backgroundColor: dalCustomColorsDark.white,
                border: `1px solid ${dalCustomColorsDark.borderColor}`
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: dalCustomColorsDark.white
                },
                "&.Mui-focused": {
                    backgroundColor: dalCustomColorsDark.white
                }
            }
        },
        MuiTextField: {
            root: {
                borderRadius: 0,
                backgroundColor: dalCustomColorsDark.fieldBackgroundColor
            }
        },
        MuiInputBase: {
            root: {
                height: 56,
                borderBottom: `1px solid ${dalCustomColorsDark.primary}`,
                borderTop: "1px solid transparent",
                "&.Mui-error": {
                    borderBottom: `1px solid ${dalCustomColorsDark.error}`
                }
            },
            multiline: {
                height: "auto"
            },
            input: {
                color: dalCustomColorsDark.primary,
                "&.Mui-disabled": {
                    color: "unset"
                },

                "&::placeholder": {
                    color: dalCustomColorsDark.primary,
                    opacity: 1
                },

                "&::-ms-input-placeholder": {
                    color: dalCustomColorsDark.primary,
                    opacity: 1
                }
            }
        },
        MuiCardContent: {
            root: {
                "&.applicantCard": {
                    borderTop: `1px solid ${dalCustomColorsDark.borderColor}`,
                    borderRight: `1px solid ${dalCustomColorsDark.borderColor}`,
                    borderBottom: `1px solid ${dalCustomColorsDark.borderColor}`
                },
                "&.applicantCardInterviews": {
                    borderLeft: `1px solid ${dalCustomColorsDark.borderColor}`,
                    borderRight: `1px solid ${dalCustomColorsDark.borderColor}`,
                    borderBottom: `1px solid ${dalCustomColorsDark.borderColor}`
                }
            }
        },
        MuiCard: {
            root: {
                "&.blackDalBorder": {
                    border: `1px solid ${dalCustomColorsDark.borderColor}`
                }
            }
        },
        MuiPaper: {
            root: {
                boxShadow: "none !important",
                "&.blackDalBorder": {
                    border: `1px solid ${dalCustomColorsDark.borderColor}`,
                    borderRadius: 4
                }
            },
            rounded: {
                borderRadius: 0
            }
        },
        MuiPaginationItem: {
            root: {
                color: dalCustomColorsDark.primary,
                border: `1px solid ${dalCustomColorsDark.primary}`
            }
        },
        MuiAutocomplete: {
            inputRoot: {
                paddingTop: "12px !important",
                paddingBottom: 12,
                height: "unset",
                minHeight: 56,
                "&.Mui-focused": {
                    paddingBottom: 10,
                    paddingTop: "10px !important"
                }
            }
        },
        MuiSelect: {
            icon: {
                fill: dalCustomColorsDark.primary
            }
        },
        MuiToggleButton: {
            root: {
                border: "none",
                borderTop: `1px solid ${dalCustomColorsDark.dataUploadBorderColor} !important`,
                borderLeft: `1px solid ${dalCustomColorsDark.dataUploadBorderColor} !important`,
                borderBottom: `1px solid ${dalCustomColorsDark.dataUploadBorderColor} !important`,
                borderRadius: 0,
                "&.Mui-selected": {
                    backgroundColor: dalCustomColorsDark.white,
                    color: dalCustomColorsDark.dataUploadBorderColor,
                    "& .MuiToggleButton-label": {
                        transform: "scale(1.2)",
                        transition: "transform 0.3s linear"
                    }
                }
            }
        },
        MuiToggleButtonGroup: {
            groupedHorizontal: {
                "&:not(:first-child)": {
                    borderRight: `1px solid ${dalCustomColorsDark.dataUploadBorderColor} !important`
                }
            }
        },
        MuiFormLabel: {
            root: {
                color: dalCustomColorsDark.primary,
                "&.Mui-focused": {
                    color: dalCustomColorsDark.primary,
                    "&.Mui-error": {
                        color: dalCustomColorsDark.error
                    }
                }
            },
            colorSecondary: {
                "&.Mui-focused": {
                    color: dalCustomColorsDark.primary
                }
            }
        },
        MuiListItem: {
            root: {
                "&.Mui-disabled": {
                    opacity: 1
                }
            }
        },
        MuiToolbar: {
            root: {
                "&.MuiPickersToolbar-toolbar": {
                    backgroundColor: dalCustomColorsDark.darkPrimary
                },
                "& .MuiPickersToolbarText-toolbarTxt": {
                    color: "#ffffff"
                },
                "& .MuiPickersToolbarText-toolbarBtnSelected": {
                    color: dalCustomColorsDark.primary
                }
            }
        },
        MuiPickersDay: {
            daySelected: {
                color: dalCustomColorsDark.white
            }
        },
        MuiPickersClockNumber: {
            clockNumberSelected: {
                color: dalCustomColorsDark.white
            }
        },
        MuiTab: {
            root: {
                textTransform: "none"
            },
            textColorInherit: {
                opacity: 1,
                color: dalCustomColorsDark.body1Dark,
                "&.Mui-selected": {
                    color: dalCustomColorsDark.primary,
                    fontWeight: 700
                }
            }
        },
        MuiTableSortLabel: {
            root: {
                "&.MuiTableSortLabel-active": {
                    color: "unset"
                },
                "&:hover": {
                    color: "unset",
                    "& .MuiTableSortLabel-icon": {
                        opacity: 1
                    }
                }
            },
            icon: {
                color: `${dalCustomColorsDark.primary} !important`
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: `1px solid ${dalCustomColorsDark.primary}`,
                fontSize: 12
            }
        },
        MuiSnackbarContent: {
            root: {
                backgroundColor: dalCustomColorsDark.errorBackground,
                color: dalCustomColorsDark.error,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `1px solid ${dalCustomColorsDark.error}`
            }
        }
    }
});
